import { axiosInstance } from "../../../config/axios";
import endpoints from "../../../config/endpoints";
import { GenericResponse } from "../../../types";

export interface Role {
	id: number;
	name: string;
    description: string;
    is_active: boolean;
    created_at: string;
    updated_at: string;
    permissions: string[];
}

export interface AvailablePermissions {
    permissions: string[];
    total: number;
}


export type CreateRoleDto = {
    name: string;
    description: string;
    is_active: boolean;
    permissions: string[];
}

export const getAvailablePermissions = async (): Promise<AvailablePermissions> => {
    const response = await axiosInstance.get<AvailablePermissions>(
        `${import.meta.env.PROD ? endpoints().roles.getAvailablePermissions : `/api/v1${endpoints().roles.getAvailablePermissions}`}`,
    );
    return response.data;
};

export const createRole = async (payload: CreateRoleDto): Promise<Role> => {
	const response = await axiosInstance.post<Role>(
		`${import.meta.env.PROD ? endpoints().roles.createRole : `/api/v1${endpoints().roles.createRole}`}`,
		payload,
	);
	return response.data;
};

export const getRoles = async (params: { page: number; limit: number }): Promise<GenericResponse<Role[]>> => {
	const response = await axiosInstance.get<GenericResponse<Role[]>>(
		`${import.meta.env.PROD ? endpoints().roles.getRoles : `/api/v1${endpoints().roles.getRoles}`}`,
		{ params },
	);
	return response.data;
};

export const getRole = async (id: number): Promise<Role> => {
	const response = await axiosInstance.get<Role>(
		`${import.meta.env.PROD ? endpoints(id).roles.getRole : `/api/v1${endpoints(id).roles.getRole}`}`,
	);
	return response.data;
};

export const updateRole = async (id: number, payload: Partial<CreateRoleDto>): Promise<Role> => {
	const response = await axiosInstance.put<Role>(
		`${import.meta.env.PROD ? endpoints(id).roles.updateRole : `/api/v1${endpoints(id).roles.updateRole}`}`,
		payload,
	);
	return response.data;
};

export const deleteRole = async (id: number): Promise<void> => {
	await axiosInstance.delete(
		`${import.meta.env.PROD ? endpoints(id).roles.deleteRole : `/api/v1${endpoints(id).roles.deleteRole}`}`,
	);
};

